import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/DeleteAccount.module.css";
import config from "../../../config";
import { pbdkf2 } from "../../../Utils/OstreonEncryption";
import { useNavigate } from "react-router-dom";
import { PaymentSuccess } from "./PaymentSuccess";
import Loading from "../../Loading/Loading";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

const base_url = config.base_url;

function DeleteAccount({ OnClose }) {
  const navigate = useNavigate();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.DeleteAccount
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.DeleteAccount);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [modal, setModal] = useState();
  const [checked, setChecked] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState({
    error: "",
    checkbox: "",
  });
  const clearMsg = () => {
    setModal();
    setTimeout(() => {
      setMsg({
        error: "",
        checkbox: "",
      });
    }, 3000);
  };
  const handleClick = async () => {
    if (password === "") {
      setMsg((prevError) => ({
        ...prevError,
        error: content.deleteAccountError1,
      }));
      clearMsg();
    }
    if (checked === false) {
      setMsg((prevError) => ({
        ...prevError,
        checkbox: content.deleteAccountError2,
      }));
      clearMsg();
    }
    if (checked === false || password === "") {
      return;
    }
    const [pbdkf2hash] = await pbdkf2(password, "OSTREON", 100000, 32 * 8);
    setModal(<Loading text={"Deleting account..."} />);
    fetch(base_url + "user/account/cancel", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `password=${pbdkf2hash}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) {
          console.log("Success");
          setModal(
            <PaymentSuccess
              button={dublicatedcontent?.dublicatedText76}
              title={content.deleteAccountText1}
              subtitle={content.deleteAccountText2}
              OnClose={() => navigate("/logout", { replace: true })}
            />
          );
        } else if (res.status === 403) {
          setMsg({
            ...msg,
            error: "You entered a wrong password. Please try again",
          });
          clearMsg();
        } else throw new Error();
      })
      .catch((e) => {
        console.log(e);
        setMsg({ ...msg, error: content.deleteAccountError3 });
        clearMsg();
      });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleClick(e);
    }
  };
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <div onClick={OnClose} className={styles.close_logo} />
        <div className={styles.title}>{content.deleteAccountTitle1}</div>
        <div className={styles.subtitle}>{content.deleteAccountTitle2}</div>

        <div className={styles.error_top}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="22"
            fill="none"
          >
            <path
              fill="#B30606"
              d="M23.04 17.39 14.112 1.713a2.456 2.456 0 0 0-.892-.908 2.409 2.409 0 0 0-2.44 0c-.371.218-.679.531-.893.908L.96 17.39a2.494 2.494 0 0 0-.011 2.477c.214.377.522.69.893.907a2.4 2.4 0 0 0 1.22.329h17.875a2.4 2.4 0 0 0 1.221-.33c.371-.216.68-.53.893-.906a2.495 2.495 0 0 0-.011-2.477ZM11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"
            />
            <path
              fill="#fff"
              d="M11.187 8.726c0-.218.086-.428.238-.583a.806.806 0 0 1 1.15 0 .832.832 0 0 1 .237.583v4.126a.831.831 0 0 1-.238.583.806.806 0 0 1-1.149 0 .831.831 0 0 1-.238-.583V8.726ZM12 17.802c-.241 0-.477-.072-.677-.208-.2-.136-.357-.33-.45-.556a1.255 1.255 0 0 1 .265-1.348 1.201 1.201 0 0 1 1.328-.268c.223.093.413.252.547.455a1.251 1.251 0 0 1-.151 1.563 1.21 1.21 0 0 1-.862.362Z"
            />
          </svg>
          <span>
            {content.deleteAccountText3}{" "}
            <a
              className={styles.link}
              target="_blank"
              href={`${window?.location?.origin}/terms-and-conditions`}
              rel="noreferrer"
            >
              {content.deleteAccountText4}
            </a>
            .
          </span>
        </div>

        <div className={styles.delete_actions}>
          <div
            onClick={(e) => {
              setChecked(!checked);
            }}
            className={`${styles.checkbox} ${
              checked ? styles.checked : styles.not_checked
            } ${msg.checkbox ? styles.input_error : ""}`}
          />
          <div className={styles.delete_text}>{content.deleteAccountText5}</div>
        </div>

        <div className={styles.pass_note}>{content.deleteAccountText6}</div>

        <div className={styles.field}>
          <input
            onKeyDown={handleEnter}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`${styles.user_input} ${
              msg.error ? styles.input_error : ""
            }`}
            placeholder={dublicatedcontent.dublicatedText62}
            type={showPassword ? "text" : "password"}
          />
          <div
            onClick={() => {
              setShowPassword(!showPassword);
            }}
            className={styles.password_button}
          >
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                fill="#B3B3B3"
              />
              <path
                d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                fill="#B3B3B3"
              />
            </svg>
          </div>
          {
            <div className={styles.login_error}>
              {msg.error ? msg.error : null}
            </div>
          }
          {
            <div className={styles.login_error}>
              {msg.checkbox ? msg.checkbox : null}
            </div>
          }
        </div>

        <div className={styles.footer}>
          <div onClick={() => handleClick()} className={styles.redbutton}>
            {content.deleteAccountText8}
          </div>
          <div onClick={OnClose} className={styles.whitebutton}>
            {dublicatedcontent.dublicatedText76}
          </div>
        </div>
      </div>
      {modal}
    </div>
  );
}
export { DeleteAccount };
